// extracted by mini-css-extract-plugin
export var filterIncDec = "_en-0";
export var leftBorder = "_en-1";
export var rightBorder = "_en-2";
export var stringInput = "_en-3";